import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';
import NoCards from '../../NoCards';
import { listStoredCards } from '../../CardsActions';
import SingleOptionRow from './SingleOptionRow';

const mapState = state => ({
  auth: state.auth,
  fetchedCards: state.cards && state.cards.fetchedCards
});

const actions = {
  listStoredCards
};

class StoredCardOption extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    listStoredCards: PropTypes.func.isRequired,
    fetchedCards: PropTypes.object
  };

  state = {
    selectedCard: {}
  };

  constructor(props) {
    super(props);

    // Destructure props
    const {
      auth: { csrfRequestIdentifier, migration },
      history,
      listStoredCards,
      fetchedCards
    } = props;

    // If session is not present, then create it
    if (!csrfRequestIdentifier) {
      history.push('/accounts/login');
    } else if (typeof listStoredCards === 'function' && !fetchedCards) {
      // If cards not pre-fetched, then fetch it
      listStoredCards(
        csrfRequestIdentifier,
        migration && migration.walletToken
      );
    }
  }

  select = selectedCard => {
    this.setState({
      selectedCard
    });

    this.props.select(selectedCard);
  };

  render() {
    const { fetchedCards } = this.props;

    // Default, show no cards image
    let content = <NoCards />;

    // From fetch cards, map and return single card option row.
    if (
      fetchedCards &&
      fetchedCards.cards &&
      Array.isArray(fetchedCards.cards)
    ) {

      if (fetchedCards.cards.length === 0) {
        return content;
      }

      content = fetchedCards.cards.map((card, index) => {
        // single card option row
        return (
          <SingleOptionRow
            card={card}
            key={card.cardToken}
            selected={index === 0}
            select={this.select}
            selectedCard={this.state.selectedCard}
          />
        );
      });
    } else if (fetchedCards && !fetchedCards.cards && fetchedCards.statusCode === 'INTERNAL_ERROR') {
      content = <Label basic color="red">Unable to fetch cards. Server Error</Label>;
    }

    return (
      <React.Fragment>
        {content}
      </React.Fragment>
    );
  }
}

export default connect(
  mapState,
  actions
)(StoredCardOption);
